import * as React from 'react';
import { Container } from 'reactstrap';
import NavMenuStore from '../NavMenuStore';

export default (props) => (
    <React.Fragment>
        <NavMenuStore />
        <section className='Signin div-flow'>
          <Container fluid={false} className='form-container-center'>
            {props.children}
        </Container>
        </section>
    </React.Fragment>
);
